/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './Snackbar.scss'
import React, { Component } from 'react'
import { appActions } from '../../../action/AppActions'
import r from '../../../util/Renderer'

class Snackbar extends Component {
  componentDidMount() {
    if (this.props.fadeout) {
      setTimeout(() => {
        appActions.disposeSnackbar()
      }, 2500)
    }
  }

  render() {
    const className = this.props.className || ''
    const type = this.props.type ? 'Snackbar__pict--' + this.props.type : ''

    return (
      <div className={`Snackbar  ${className}`}>
        {r.renderIf(this.props.type !== 'error')(<div className={`Snackbar__pict ${type}`} />)}
        <span className="Snackbar__message">{this.props.children}</span>
        <div className="Snackbar__close" onClick={e => appActions.disposeSnackbar()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <g fill="none" fillRule="evenodd" stroke="#A2A2A2" strokeLinejoin="round" strokeWidth="1.5">
              <path d="M17.068 7l-9.9 9.9M17.068 16.9L7.168 7" />
            </g>
          </svg>
        </div>
      </div>
    )
  }
}

export default Snackbar
